import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoOutputDto } from "../../domain/DTOs/output/estrutura-retorno.output.dto";
import { enviarEmailContato, enviarEmailContatoFailure, enviarEmailContatoFinish, enviarEmailContatoSuccess } from "../actions/enviar-email-contato.action";

export interface EnviarEmailContatoState {
    response: EstruturaRetornoOutputDto | null;
    error: string[] | null;
}

export const initialState: EnviarEmailContatoState = {
    response: null,
    error: null,
};

export const EnviarEmailContatoReducer = createReducer(
    initialState,
    on(enviarEmailContato, state => ({ ...state, error: null })),
    on(enviarEmailContatoSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(enviarEmailContatoFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(enviarEmailContatoFinish, state => ({ ...state, response: null, error: null }))
);
